import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { loginPath, onboardingPath } from '../utils/calFlow';

export default function PrivateRoute({ children, skipOnboardingCheck = false }) {
  const { user, userRecord, loading } = useAuth();
  const location = useLocation();

  // Only block on the top-level auth loading — recordLoading is covered by AuthContext spinner
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-100">
        <div className="w-6 h-6 border-2 border-primary-100 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={loginPath(location.search)} state={{ from: location.pathname }} replace />;
  }

  // Only redirect new users who explicitly have onboarding_completed = false
  // NULL means existing user pre-dating the onboarding flow — let them through
  if (!skipOnboardingCheck && userRecord?.onboarding_completed === false) {
    return <Navigate to={onboardingPath(location.search)} replace />;
  }

  return children;
}
